<template>
  <div style="">
    <div class="t_joinbox">
      <img
        src="@/assets/img/rwsq.png"
        style="
          width: 150px;
          display: block;
          margin-left: auto;
          margin-right: auto;
        "
      >
      <div class="t_font bg_color">
        根据《易制毒化学品管理条例》，单位从事易制毒化学品生产、经营、使用、运输、仓储等需要在行政区划申请；如果您的单位已经入网，请联系单位信息员将您的手机号及个人信息登记在单位从业人员里。（此处不需要再次注册个人及单位信息）
      </div>
      <div
        class="t_font"
        style="font-size: 14px; padding-top: 0; margin-top: 0"
      >
        开始单位入网申请前，请先准备好以下证件资料的扫描件或照片（<span
          style="color: blue"
        >图片格式：JPG/BMP/JPEG/PNG</span>)
      </div>
      <div class="t_zj_box">
        <div class="t_title_item">
          <img
            src="@/assets/img/grzj.png"
            style="width: 22px; margin-right: 9px"
          >个人/法人/经营者证件
        </div>
        <div class="t_card_list">
          <div class="t_card bg_color">个人身份证正反面图片</div>
          <div class="t_card bg_color">法人身份证正反面图片</div>
          <div class="t_card bg_color">经营者身份证正反面图片</div>
        </div>
      </div>
      <div class="t_zj_box">
        <div class="t_title_item">
          <img
            src="@/assets/img/qyzj.png"
            style="width: 22px; margin-right: 9px"
          >单位证件
        </div>
        <div class="t_card_list">
          <!-- <div class="t_card bg_color">安全生产许可证</div>
                <div class="t_card bg_color">非药品类易制毒化学品生产许可证</div>
                <div class="t_card bg_color">非药品类易制毒化学品生产备案证明</div>
                <div class="t_card bg_color">非药品类易制毒化学品生产二类备案证明</div>
                <div class="t_card bg_color">非药品类易制毒化学品生产三类备案证明</div>
                <div class="t_card bg_color">危险化学品经营许可证</div>
                <div class="t_card bg_color">非药品类易制毒化学品经营许可证</div>
                <div class="t_card bg_color">非药品类易制毒化学品经营备案证明</div>
                <div class="t_card bg_color">非药品类易制毒化学品经营二类备案证明</div>
                <div class="t_card bg_color">非药品类易制毒化学品经营三类备案证明</div>
                <div class="t_card bg_color">道路运输经营许可证</div> -->
          <div
            class="t_font"
            style="
              font-size: 14px;
              padding-top: 0;
              margin-top: 0;
              padding-bottom: 0;
            "
          >
            合法使用需要证明（每种化学品一张）
          </div>
          <table
            border="1"
            cellspacing="0"
            cellpadding="0"
            style="
              border-collapse: collapse;
              width: 100%;
              border-color: #cfcfcf;
            "
            class="t_table"
          >
            <tr>
              <td style="font-weight: bold; text-align: center; width: 22%">
                单位业务类型
              </td>
              <td style="font-weight: bold; text-align: center; width: 10%">
                单位性质
              </td>
              <td style="font-weight: bold; text-align: center; width: 40%">
                必须提供
              </td>
              <td style="font-weight: bold; text-align: center">可选</td>
            </tr>
            <tr>
              <td>一类易化品生产</td>
              <td>企业</td>
              <td>营业执照、非药品类易制毒化学品生产许可证</td>
              <td>安全生产许可证、其它证件</td>
            </tr>
            <tr>
              <td>二、三类易化品生产</td>
              <td>企业</td>
              <td>营业执照、非药品类易制毒化学品生产备案证明</td>
              <td>安全生产许可证、其它证件</td>
            </tr>
            <tr>
              <td>一类易化品经营</td>
              <td>企业</td>
              <td>营业执照、非药品类易制毒化学品经营许可证</td>
              <td>危险化学品经营许可证、合法使用需要证明、其它证件</td>
            </tr>
            <tr>
              <td>二、三类易化品经营</td>
              <td>企业</td>
              <td>营业执照、非药品类易制毒化学品经营备案证明</td>
              <td>危险化学品经营许可证、合法使用需要证明、其它证件</td>
            </tr>
            <tr>
              <td rowspan="5">一、二类易化品使用</td>
              <td>企业</td>
              <td>营业执照</td>
              <td>合法使用需要证明、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>社会团体</td>
              <td rowspan="4">登记证书/成立批准文件</td>
              <td>合法使用需要证明、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>事业单位</td>
              <!-- <td rowspan="4">登记证书/成立批准文件</td> -->
              <td>合法使用需要证明、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>党政机关</td>
              <!-- <td rowspan="4">登记证书/成立批准文件</td> -->
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>军队</td>
              <!-- <td rowspan="4">登记证书/成立批准文件</td> -->
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <td rowspan="6">三类易化品使用</td>
              <td>企业</td>
              <td>营业执照</td>
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>社会团体</td>
              <td rowspan="4">登记证书/成立批准文件</td>
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>事业单位</td>
              <!-- <td rowspan="4">登记证书/成立批准文件</td> -->
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>党政机关</td>
              <!-- <td rowspan="4">登记证书/成立批准文件</td> -->
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>军队</td>
              <!-- <td rowspan="4">登记证书/成立批准文件</td> -->
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <!-- <td rowspan="5">一、二类易化品使用</td> -->
              <td>个人</td>
              <!-- <td rowspan="4">登记证书/成立批准文件</td> -->
              <td>
                身份证/港澳台居民居住证/港澳居民来往内地通行证/台湾居民来往大陆通行证/护照/外国人永久居留身份证
              </td>
              <td>合法使用需要证明 、其它证件</td>
            </tr>
            <tr>
              <td>一、二、三类易化品运输</td>
              <td>企业</td>
              <td>营业执照、道路运输经营许可证</td>
              <td>危险货物道路运输许可证、其它证件</td>
            </tr>
            <tr>
              <td>一、二、三类易化品仓储</td>
              <td>企业</td>
              <td>营业执照</td>
              <td>危险化学品经营许可证、其它证件</td>
            </tr>
          </table>
        </div>
      </div>
      <router-link class="t_start" to="/rwsqstep">开始注册</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Rwsq',
  components: {
    // sideMenu,
    // Header
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
.t_joinbox {
  width: 964px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  padding: 55px;
}
.bg_color {
  background-color: #f7f7f7;
}
.t_font {
  font-size: 15px;
  padding: 20px 30px;
  border-radius: 5px;
  margin-top: 37px;
  margin-bottom: 20px;
}
.t_title_item {
  display: flex;
  font-size: 17px;
  align-items: center;
  margin-bottom: 20px;
}
.t_card {
  font-size: 15px;
  border-radius: 5px;
  padding: 20px 25px;
  margin-right: 30px;
  margin-bottom: 20px;
}
.t_zj_box {
  margin-bottom: 20px;
}
.t_card_list {
  display: flex;
  flex-wrap: wrap;
}
.t_start {
  font-size: 16px;
  width: 376px;
  line-height: 60px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  background-color: #4170ff;
  border-radius: 5px;
  color: white;
  margin-top: 60px;

  display: block;
  text-decoration: none;
}
.t_table td {
  padding: 5px 10px;
  color: #333333;
  font-size: 14px;
}
</style>
